import { SVGProps } from "react"

const SmallLogo = ({ color, height, width, ...props }: SVGProps<SVGSVGElement>) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6562_3595)">
                <path fillRule="evenodd" clipRule="evenodd" d="M11.2479 19.1112C4.28541 19.1506 1.50938 12.3974 3.19186 5.64016C6.51964 0.926603 12.7353 -1.30425 19.1922 0.787437C18.4476 1.61611 18.7091 1.39941 17.9606 2.20424C12.5777 7.9946 8.62649 25.0132 21.4997 27.1149C19.3076 29.019 14.7045 29.3938 11.4042 28.7049C0.712758 26.4734 -2.9173 13.6197 2.46555 6.6388C1.87732 10.7351 1.56445 13.9053 3.76751 17.6377C5.26583 20.1764 7.4576 22.176 11.8368 21.9626L11.2479 19.1112L11.2479 19.1112Z" fill={color ?? "#2F60E0"} />
                <path fillRule="evenodd" clipRule="evenodd" d="M16.8546 20.2751C17.6824 23.4493 20.4857 25.2753 24.6287 25.1331C26.3878 23.0179 28.496 20.355 28.9419 16.0914C29.3795 11.9053 28.0441 8.29147 26.0228 5.88135C24.0965 13.0951 22.7713 15.8313 16.8546 20.2751V20.2751Z" fill={color ?? "#2F60E0"} />
                <path fillRule="evenodd" clipRule="evenodd" d="M16.0383 15.5676C19.5549 14.5461 22.8976 8.41117 23.4835 3.34575L22.3963 2.5542C17.9238 6.11271 15.675 12.6572 16.0383 15.5676Z" fill={color ?? "#2F60E0"} />
            </g>
            <defs>
                <clipPath id="clip0_6562_3595">
                    <rect width="29.0252" height="29.0252" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default SmallLogo